export const deleteLocalStorage = async (key: string) => {
  try {
    await localStorage.removeItem(key);
  } catch (error) {
    console.error("Error reading from localStorage:", error);
  }
};
